import type { CSSProperties, ReactElement } from 'react';

interface SkeletonProps {
  readonly w?: string | number;
  readonly h?: string | number;
  readonly radius?: string;
  readonly style?: CSSProperties;
}

export function Skeleton({ w = '100%', h = 12, radius, style }: SkeletonProps): ReactElement {
  return (
    <div
      className="sk"
      style={{
        width: typeof w === 'number' ? `${w}px` : w,
        height: typeof h === 'number' ? `${h}px` : h,
        ...(radius === undefined ? {} : { borderRadius: radius }),
        ...style,
      }}
    />
  );
}

/** N linhas empilhadas — o estado de carregamento padrao de qualquer lista. */
export function SkeletonRows({
  rows = 4,
  height = 56,
}: {
  readonly rows?: number;
  readonly height?: number;
}): ReactElement {
  return (
    <div style={{ display: 'grid', gap: 'var(--space-3)' }}>
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} h={height} radius="var(--radius-md)" />
      ))}
    </div>
  );
}
